import { AppBar, Avatar, Toolbar } from "@mui/material"
import { Box } from "@mui/system"

const AppHeader = () => {
	return (
		<AppBar position="static" color="default">
			<Toolbar>
				<Box height="80%">
					<Avatar sx={{width: '47px', height: 'auto'}} variant="square" alt="fire-smart-logo" src="/fire-smart-logo.png" />
				</Box>
			</Toolbar>
		</AppBar>
	)
}

export default AppHeader